module.exports = __webpack_public_path__ + "static/immovable_rod-cf065d43edf1aad8d60870e49b4da7d2.jpeg";